(function () {
  const initSection = async (section) => {
    if (!section || !section?.classList.contains("recently-viewed-section")) {
      return;
    }

    const box = section.querySelector(".recently-viewed");
    if (!box) return;

    const STORAGE_KEY = "__theme__recently_products";
    const EXPIRATION_DAYS = box.dataset.expirationDays
      ? Number(box.dataset.expirationDays)
      : 30;
    const dateNow = Date.now();

    const baseUrl = box.dataset.baseUrl;
    const productsLimit = Number(box.dataset.productsLimit) || 6;
    const currentPageProductId = box.dataset.currentPageProductId;

    // get recent products from local storage
    let recentProducts = [];
    try {
      recentProducts = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      console.error(`Incorrect value in local storage for "${STORAGE_KEY}"`);
    }

    if (currentPageProductId) {
      recentProducts = recentProducts.filter(
        (item) => item.productId !== currentPageProductId
      );
    }

    if (recentProducts.length === 0) {
      box.classList.remove("recently-viewed--loading");
      box.classList.add("recently-viewed--empty");
      return;
    }

    // filter by expiration time
    const expirationTime = EXPIRATION_DAYS * 24 * 60 * 60 * 1000;
    const validProducts = recentProducts.filter(
      (item) => dateNow - item.timestamp < expirationTime
    );
    localStorage.setItem(STORAGE_KEY, JSON.stringify(validProducts));

    // limit by section setting
    const limitedProducts = validProducts.slice(0, productsLimit);
    if (limitedProducts.length === 0) {
      box.classList.remove("recently-viewed--loading");
      box.classList.add("recently-viewed--empty");
      return;
    }

    // get url with query
    const query = limitedProducts
      .filter((item) => item.productId)
      .map((item) => `id:${item.productId}`)
      .join("%20OR%20");
    const url = `${baseUrl}&q=${query}`;

    try {
      const response = await fetch(url);
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");
      const sourceBox = doc?.querySelector(".recently-viewed");
      if (!sourceBox?.classList.contains("recently-viewed--search-perfomed")) {
        box.classList.add("recently-viewed--empty");
        return;
      }

      // Search results are not guaranteed to follow the browsing order.
      // Reorder the cards so the most recently viewed product is first.
      const productOrder = limitedProducts.map((item) => String(item.productId));
      const sourceList = sourceBox.querySelector(".popular-products__list");
      const sourceItems = Array.from(sourceList?.children || []);
      sourceItems
        .sort((a, b) => {
          const aId = String(a.querySelector(".product-card")?.dataset.productId || "");
          const bId = String(b.querySelector(".product-card")?.dataset.productId || "");
          return productOrder.indexOf(aId) - productOrder.indexOf(bId);
        })
        .forEach((item) => sourceList.appendChild(item));

      box.innerHTML = sourceBox.innerHTML;

      document.dispatchEvent(
        new CustomEvent("heading-slider:load", {
          bubbles: true,
        })
      );
    } catch (error) {
      console.error("Failed to fetch recently viewed products:", error);
      box.classList.add("recently-viewed--empty");
    } finally {
      box.classList.remove("recently-viewed--loading");
    }
  };

  initSection(document.currentScript.parentElement);

  document.addEventListener("shopify:section:load", function (event) {
    initSection(event.target);
  });
})();
